import { clientDatumInfoBoxDataWithBoundsForSelection } from '@upright/ui/common/upright/core/impact-lens-profile/common/client-datums-to-boxes';
import { CarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { LeftAndRightImpactSelectionState } from '@upright/ui/common/upright/core/impact-lens-profile/selection-state/separate-left-right-selection-state';
import {
  ImpactTarget,
  ImpactTargetOrSbtiTarget,
  SbtiTarget,
} from '@upright/ui/common/upright/core/impact-lenses/targets/common/types';
import { ClientDatumInfoBoxDataWithBounds } from '../../../impact-lens-profile/common/client-datums-to-boxes/types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TargetInfoBoxDataWithBounds extends ClientDatumInfoBoxDataWithBounds<ImpactTargetOrSbtiTarget> {}

export function getTargetInfoBoxDataWithBoundsForSelection(
  baseLayout: CarouselLayout,
  targets: ImpactTargetOrSbtiTarget[],
  lensIndex: number,
  previousLensIndex: number | undefined,
  selection: LeftAndRightImpactSelectionState | undefined,
): TargetInfoBoxDataWithBounds[] {
  return clientDatumInfoBoxDataWithBoundsForSelection(baseLayout, targets, lensIndex, previousLensIndex, selection);
}

export function mergeTargets(
  targets: ImpactTarget[] | undefined,
  sbtiTargets: SbtiTarget[] | undefined,
): ImpactTargetOrSbtiTarget[] | undefined {
  if (!targets && !sbtiTargets) {
    return undefined;
  }
  if (!targets) {
    return sbtiTargets;
  }
  if (!sbtiTargets) {
    return targets;
  }
  return [...sbtiTargets, ...targets];
}
